import KIcon from '../icon'

/**
 * trigger 指示器
 */
export default {
  name: 'KTriggerIndicator',
  props: {
    reverse: {
      type: Boolean,
      default: false,
    },
    placement: {
      type: String,
      validator: (value) => ['top', 'bottom'].indexOf(value) !== -1,
      default: 'bottom',
    },
  },
  render() {
    const icon = 'angle-' + (this.placement === 'top' ? 'up' : 'down')
    const className = {
      'sati-rotate-180': this.reverse,
    }

    return <KIcon class={className} icon={icon} />
  },
}
